import { useCallback, useMemo } from 'react';

import { useAtomValue, useSetAtom } from 'jotai';

import { SwingThread } from '@blocks';
import { useSwingFoundationParameters } from '@hooks';
import { useTranslate } from '@i18n';
import { activeSwingIdAtom, swingThreadToggleAtom, currentFrameAtom, activeUserIdAtom } from '@store';

type SwingThreadFromProps = {
    onClose: () => void;
    activePosition: number;
};

export const SwingThreadForm = ({ onClose, activePosition }: SwingThreadFromProps) => {
    const activeSwingId = useAtomValue(activeSwingIdAtom);
    const activeUserId = useAtomValue(activeUserIdAtom);
    const setShowThreads = useSetAtom(swingThreadToggleAtom);
    const fromFrame = useAtomValue(currentFrameAtom);
    const params = useSwingFoundationParameters(activePosition);
    const t = useTranslate();
    const options = useMemo(() => params?.map((d) => ({ label: t(d.i18n ?? '-'), value: d.id })), [params, t]);
    const handlePostUpsert = useCallback(async () => {
        onClose();
        setShowThreads(true);
    }, [setShowThreads, onClose]);
    return (
        <SwingThread
            initialPositionX={320}
            initialPositionY={190}
            swingUuid={activeSwingId}
            options={options ?? []}
            fromFrame={fromFrame}
            activeUserId={activeUserId ?? ''}
            onPostUpsertThread={handlePostUpsert}
            onClose={onClose}
        />
    );
};
